import React, { Component } from 'react';
import { HeaderNav } from './Header';
import TopVeranstaltungen from './TopVeranstaltungen';
import Footer from './footer';

class AppStore extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div
        style={{
          textAlign: 'center'
        }}
      >
      </div>
    );
  }
}

export default AppStore;
